import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9be3a6f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "devices is-light" }
const _hoisted_2 = { class: "devices__body" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "device" }
const _hoisted_5 = {
  key: 0,
  class: "cureent-device"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备在线", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]

import { computed, ref, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { DEVICE_LAST_ID } from '@remote/constant'
import { setLocalValue, toast } from '@remote/utils/index'
import global from '@remote/store/constantStore'
import { useEnvStore } from '@remote/store/env'
import { stat } from '@remote/utils/stat'
import { signOutFromInnerProxy } from '@remote/api/proxy'
import { openPopMenu } from '@remote/utils/dialog'
import { safeJSONParse } from '@shared/utils'
import { setApiEnv } from '@remote/api/config'


export default /*#__PURE__*/_defineComponent({
  props: {
  close: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props


const store = useStore()
const envStore = useEnvStore()
const quitIndex = ref(0)
const isRemoveDevice = ref('no')
const isChangeDevice = ref('no')
const action = computed(() => store.state.action)
const runners = computed(() => store.state.runners)
const all = computed(() => store.state.all)
const curDeviceRunner = computed(() => store.state.curDeviceRunner)
const list = computed(() => {
  const devices = runners.value.map(id => all.value[id])
  return devices
})

const handleClick = (index: number) => {
  const device = list.value[index]
  if (device?.params?.platform) {

    if (device?.params?.platform === 'xlbox') {
      global.isXlBox = true
      setApiEnv('heziDevelopment')
    } else {
      setApiEnv('production')
      window.location.href = `//pan.xunlei.com/yc?space=${encodeURIComponent(device.params.target)}`
      return
    }

    envStore.updateEnv({
      platform: device.params.platform,
      plm: device.params.platform,
    })
  }
  stat({action: 'change_device_click'})
  if (device.status === 0) return
  setTimeout(() => {
    isChangeDevice.value = 'yes'
    props.close()
  }, 500)
  if (device.params) {
    localStorage.setItem(DEVICE_LAST_ID, device.params.target)
    store.commit('update', { space: device.params.target, status: device.status, curDeviceRunner: device, currentSpped: 0 })
    store.commit('update', { deviceInfoWatchData: {
      ...store.state.deviceInfoWatchData ?? {},
      space: device.params.target,
    }})
    envStore.updateEnv({
      space: device.params.target,
    })
    setLocalValue ('curDeviceRunner', curDeviceRunner.value)
    global.fromSpace = device.params.target
    global.curDeviceConfig = device.params.device_config
    store.dispatch('getTasks')
    store.dispatch('checkPrivilegeAuth')
    store.dispatch('getDeviceInfoWatch')
  } else {
    store.commit('update', { space: '', status: device.status, currentSpped: 0 })
  }
}
const handleQuit = async (runner: API_TASK.DriveTask) => {
  // pc设备不能通过远程来退出登录态
  if (runner.space === 'platform#pcxllite') {
    toast('请前往电脑端退出当前账号')
    return
  }
  if (runner.phase == 'PHASE_TYPE_RUNNING') {
    const result = await openPopMenu({
      title: '确定退出登录？',
      description: '退出该设备的登录状态后，将无法继续远程控制；您可以重新登录继续远程控制',
      options: ['确定', '取消'],
      themeClass: 'is-light',
    })
    if (result === '确定') {
      isRemoveDevice.value = 'yes'
      const deviceConfig = safeJSONParse(runner.params?.device_config) as API_DEVICE.DeviceConfig
      await signOutFromInnerProxy(runner.params?.target ?? '', deviceConfig?.device_space ?? '')
      store.dispatch('getRunner')
    }
  } else {
    const result = await openPopMenu({
      title: '确定移除设备？',
      description: '移除离线设备后，该设备将不会出现在本列表；您再次登录时，该设备会重新出现',
      options: ['确定', '取消'],
      themeClass: 'is-light',
    })
    if (result === '确定') {
      isRemoveDevice.value = 'yes'
      store.dispatch('deleteRunner', runner.id)
    }
  }
}

onBeforeUnmount(() => {
  stat({
    action: 'remote_device_supernatant_close',
    data: { if_change_device: isChangeDevice.value, if_remove_device: isRemoveDevice.value },
  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass(["devices__body-frame", {'disabled': item.status !== 1, 'current': _unref(curDeviceRunner).id === item.id && item.status === 1}])
        }, [
          _createElementVNode("div", {
            class: "devices__body-name",
            onClick: ($event: any) => (handleClick(index))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.name + (item.status === 0 ? '(离线)' : '')), 1),
            (item.status === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3),
          (_unref(curDeviceRunner).params.platform !== 'xlbox')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:;",
                class: _normalizeClass(item.status === 1 ? 'qh-icon-quit':'qh-icon-delete-nav'),
                onClick: ($event: any) => (handleQuit(item))
              }, null, 10, _hoisted_8))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ]))
}
}

})